import { LoadableResponse } from "api-types";
import { collection, getDocs, query } from "firebase/firestore/lite";
import { useFirebase } from "igfd-commons";

import { useMemo, useState } from "react";

import type { Tag } from "@dashboard/types";

/**
 * Query an internal metadata collection (like allergens / preferences)
 *
 * This data doesn't change, and hence we don't listen for updates.
 */
export const useTags: (restaurantUuid: string) => LoadableResponse<Tag[]> = (
  restaurantUuid: string
) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<Tag[]>([]);
  const firebase = useFirebase();

  useMemo(() => {
    getDocs(query(collection(firebase.firestore, "tags")))
      .then((querySnapshot) =>
        setData(
          getTagsForRestaurant(
            restaurantUuid,
            querySnapshot.docs.map((doc) => doc.data() as Tag)
          )
        )
      )
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [restaurantUuid, firebase]);

  return {
    isLoading: loading,
    data: data,
  };
};

const getTagsForRestaurant = (restaurantUuid: string, docs: Tag[]) => {
  // handle restricted restaurants
  return docs.filter(
    (tag) =>
      tag.restrictedRestaurantUuids.length === 0 ||
      tag.restrictedRestaurantUuids.includes(restaurantUuid)
  );
};
